import React, {useContext} from "react";
import "./Popup.scss";
import PopupContext from "./PopupContext";

const Popup = (props) => {
  const {setPopupContent} = useContext(PopupContext);
  return <div className={'popup-wrap'}>
    <div className={'popup' + (props.className ? " " + props.className : "")} style={props.style}>
      <div className={'popup-title'}>{props.title}</div>
      {props.children}
      <div className={'popup-buttons'}>
        {props.onConfirm &&
          <>
            {props.disableConfirm ?
              <div className={'simple-button popup-button confirm disabled'}>
                {props.confirmButton || "OK"}
              </div>
              :
              <div className={'simple-button popup-button confirm'} onClick={() => {
                props.onConfirm();
                if (typeof setPopupContent === "function") setPopupContent(false)
              }}>
                {props.confirmButton || "OK"}
              </div>
          }
          </>
        }
        <div className={'simple-button popup-button cancel'} onClick={() => {props.onCancel && props.onCancel();if (typeof setPopupContent === "function") setPopupContent(false)}}>
          {props.cancelButton || "Abbrechen"}
        </div>
      </div>
    </div>
  </div>
}

export default Popup;